var _dec, _dec2, _dec3, _dec4, _dec5, _dec6, _dec7, _dec8, _dec9, _dec0, _dec1, _dec10, _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _descriptor6, _descriptor7, _descriptor8, _descriptor9, _descriptor0, _descriptor1, _descriptor10, _dec11, _dec12, _dec13, _dec14, _class2, _descriptor11, _descriptor12, _descriptor13, _descriptor14;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import objectArrayTrait from "../../Decorators/objectArrayTrait";
import objectTrait from "../../Decorators/objectTrait";
import primitiveArrayTrait from "../../Decorators/primitiveArrayTrait";
import primitiveTrait from "../../Decorators/primitiveTrait";
import mixTraits from "../../mixTraits";
import ScaleByDistanceTraits from "../ScaleByDistanceTraits";
import { BinStyleTraits, EnumStyleTraits, TableStyleMapSymbolTraits, TableStyleMapTraits } from "./StyleMapTraits";

/** Supports subset of CZML Label https://github.com/AnalyticalGraphicsInc/czml-writer/wiki/Label
 *
 * Unimplemented properties
 * - show
 * - eyeOffset
 * - horizontalOrigin
 * - verticalOrigin
 * - heightReference
 * - showBackground
 * - backgroundColor
 * - backgroundPadding
 * - translucencyByDistance
 * - pixelOffsetScaleByDistance
 * - scaleByDistance
 * - distanceDisplayCondition
 * - disableDepthTestDistance

 */
export let LabelSymbolTraits = (_dec = primitiveTrait({
  name: "Label column",
  description: "ID of column to use as label",
  type: "string"
}), _dec2 = primitiveTrait({
  name: "Font",
  description: "Font CSS string. Default is `30px sans-serif`.",
  type: "string"
}), _dec3 = primitiveTrait({
  name: "Style",
  description: 'Label style. Possible values are `"FILL"`, `"OUTLINE"` and `"FILL_AND_OUTLINE"`. Default is `"FILL"`.',
  type: "string"
}), _dec4 = primitiveTrait({
  name: "Scale",
  description: "The scale of the label. The scale is multiplied with the pixel size of the label's text.",
  type: "number"
}), _dec5 = objectTrait({
  name: "Scale by distance",
  description: "Scales a point, billboard or label feature by its distance from the camera.",
  type: ScaleByDistanceTraits,
  isNullable: true
}), _dec6 = primitiveTrait({
  name: "Disable depth test distance",
  description: "The distance from camera at which to disable depth testing, for example to prevent clipping of features againts terrain. Set to a very large value like 99999999 to disable depth testing altogether. When not defined or set to 0, depth testing is always applied.",
  type: "number"
}), _dec7 = primitiveTrait({
  name: "Fill color",
  description: "The fill color of the label.",
  type: "string"
}), _dec8 = primitiveTrait({
  name: "Outline color",
  description: "The outline color of the label.",
  type: "string"
}), _dec9 = primitiveTrait({
  name: "Outline width",
  description: "The outline width of the label.",
  type: "number"
}), _dec0 = primitiveArrayTrait({
  name: "Pixel offset",
  description: "The number of pixels up and to the right to place the label.",
  type: "number"
}), _dec1 = primitiveTrait({
  name: "Horizontal origin",
  description: 'The horizontal location of an origin relative to an object. For example, LEFT will place the label on the right of the point. Possible values are `"LEFT"`, `"CENTER"` and `"RIGHT"`. Default is `"RIGHT"`.',
  type: "string"
}), _dec10 = primitiveTrait({
  name: "Vertical origin",
  description: 'The vertical location of an origin relative to an object. For example, TOP will place the label above the point. Possible values are `"TOP"`, `"CENTER"`, `"BASELINE"` and `"BOTTOM"`. Default is `"CENTER"`.',
  type: "string"
}), _class = class LabelSymbolTraits extends mixTraits(TableStyleMapSymbolTraits) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "labelColumn", _descriptor, this);
    _initializerDefineProperty(this, "font", _descriptor2, this);
    _initializerDefineProperty(this, "style", _descriptor3, this);
    _initializerDefineProperty(this, "scale", _descriptor4, this);
    _initializerDefineProperty(this, "scaleByDistance", _descriptor5, this);
    _initializerDefineProperty(this, "disableDepthTestDistance", _descriptor6, this);
    _initializerDefineProperty(this, "fillColor", _descriptor7, this);
    _initializerDefineProperty(this, "outlineColor", _descriptor8, this);
    _initializerDefineProperty(this, "outlineWidth", _descriptor9, this);
    _initializerDefineProperty(this, "pixelOffset", _descriptor0, this);
    _initializerDefineProperty(this, "horizontalOrigin", _descriptor1, this);
    _initializerDefineProperty(this, "verticalOrigin", _descriptor10, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "labelColumn", [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "font", [_dec2], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "30px sans-serif";
  }
}), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "style", [_dec3], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "FILL";
  }
}), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "scale", [_dec4], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "scaleByDistance", [_dec5], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor6 = _applyDecoratedDescriptor(_class.prototype, "disableDepthTestDistance", [_dec6], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor7 = _applyDecoratedDescriptor(_class.prototype, "fillColor", [_dec7], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "#ffffff";
  }
}), _descriptor8 = _applyDecoratedDescriptor(_class.prototype, "outlineColor", [_dec8], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "#000000";
  }
}), _descriptor9 = _applyDecoratedDescriptor(_class.prototype, "outlineWidth", [_dec9], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 1;
  }
}), _descriptor0 = _applyDecoratedDescriptor(_class.prototype, "pixelOffset", [_dec0], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [0, 0];
  }
}), _descriptor1 = _applyDecoratedDescriptor(_class.prototype, "horizontalOrigin", [_dec1], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "LEFT";
  }
}), _descriptor10 = _applyDecoratedDescriptor(_class.prototype, "verticalOrigin", [_dec10], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return "CENTER";
  }
}), _class);
export class EnumLabelSymbolTraits extends mixTraits(LabelSymbolTraits, EnumStyleTraits) {}
_defineProperty(EnumLabelSymbolTraits, "isRemoval", EnumStyleTraits.isRemoval);
export class BinLabelSymbolTraits extends mixTraits(LabelSymbolTraits, BinStyleTraits) {}
_defineProperty(BinLabelSymbolTraits, "isRemoval", BinStyleTraits.isRemoval);
let TableLabelStyleTraits = (_dec11 = primitiveTrait({
  name: "Enabled",
  description: "True to enable. False by default",
  type: "boolean"
}), _dec12 = objectArrayTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: EnumLabelSymbolTraits,
  idProperty: "value"
}), _dec13 = objectArrayTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: BinLabelSymbolTraits,
  idProperty: "index"
}), _dec14 = objectTrait({
  name: "Enum Colors",
  description: "The colors to use for enumerated values. This property is ignored " + "if the `Color Column` type is not `enum`.",
  type: LabelSymbolTraits
}), _class2 = class TableLabelStyleTraits extends mixTraits(TableStyleMapTraits) {
  constructor() {
    super(...arguments);
    // Override TableStyleMapTraits.enabled default
    _initializerDefineProperty(this, "enabled", _descriptor11, this);
    _initializerDefineProperty(this, "enum", _descriptor12, this);
    _initializerDefineProperty(this, "bin", _descriptor13, this);
    _initializerDefineProperty(this, "null", _descriptor14, this);
  }
}, _descriptor11 = _applyDecoratedDescriptor(_class2.prototype, "enabled", [_dec11], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return false;
  }
}), _descriptor12 = _applyDecoratedDescriptor(_class2.prototype, "enum", [_dec12], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor13 = _applyDecoratedDescriptor(_class2.prototype, "bin", [_dec13], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return [];
  }
}), _descriptor14 = _applyDecoratedDescriptor(_class2.prototype, "null", [_dec14], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return new LabelSymbolTraits();
  }
}), _class2);
export { TableLabelStyleTraits as default };